(function(){
'use strict';

/**
 * @name replaceUnderscoreWithBlank
 * @kind filter
 * To replace Underscore with Blank.
 */

function replaceUnderscoreWithBlank() {
  return function (input) {
    return input.replace(/_/g, ' ');
  };
}

angular.module('classy').filter('replaceUnderscoreWithBlank', replaceUnderscoreWithBlank);
})();